export default () => ({
  el: undefined,
  previousPage: undefined,
  nextPage: undefined,
  lastPage: undefined,
  firstPage: undefined,
  inFlight: false,
  init() {
    mrp.log(`RxDataGridFooter init`);
    this.el = this.$el;
    const useInfiniteScroll = this.el.getAttribute("data-use-infinite-scroll");
    if (useInfiniteScroll === "true") {
      return;
    }
    const gridId = this.el.getAttribute("data-grid-id");
    this.previousPage = this.$refs.previousPage;
    this.nextPage = this.$refs.nextPage;
    this.firstPage = this.$refs.firstPage;
    this.lastPage = this.$refs.lastPage;
    const page = this.el.getAttribute("data-page");
    sessionStorage.setItem(`${gridId}-page`, page);
    const pageSize = this.el.getAttribute("data-page-size");
    const totalRecords = this.el.getAttribute("data-total-records");
    const n = parseInt(page);
    if (Number.isNaN(n)) {
      return;
    }
    if (n > 1) {
      const hasData = this.el.getAttribute("data-page-has-data");
      if (hasData === "false") {
        this.setPager(n - 1);
        return;
      }
    }
    if (n === 1) {
      this.previousPage.setAttribute("disabled", "");
      this.firstPage.setAttribute("disabled", "");
    }
    if (n * pageSize >= totalRecords) {
      this.nextPage.setAttribute("disabled", "");
      this.lastPage.setAttribute("disabled", "");
    }
  },
  click(evt) {
    const containerId = evt.currentTarget.getAttribute(
      "data-grid-container-id"
    );
    const ele = document.getElementById(containerId);
    ele.scrollTop = 0;
  },
  pageNext() {
    const page = this.el.getAttribute("data-page");
    const n = parseInt(page);
    if (Number.isNaN(n)) {
      return;
    }
    this.setPager(n + 1, "current-page");
  },
  pagePrevious() {
    const page = this.el.getAttribute("data-page");
    const n = parseInt(page);
    if (Number.isNaN(n)) {
      return;
    }
    this.setPager(n - 1, "current-page");
  },
  pageFirst() {
    this.setPager(1, "current-page");
  },
  pageLast() {
    const pageSize = this.el.getAttribute("data-page-size");
    const totalRecords = this.el.getAttribute("data-total-records");
    const page = Math.ceil(totalRecords / pageSize);
    this.setPager(page, "current-page");
  },
  setPager(page, focus) {
    if (page !== undefined && page !== null) {
      const endpoint = this.el.getAttribute("data-endpoint");
      if (
        endpoint === undefined ||
        endpoint === null ||
        endpoint.toString().trim() === ""
      ) {
        return;
      }
      const gridId = this.el.getAttribute("data-grid-id");
      const filter = sessionStorage.getItem(`${gridId}-filter`) ?? "";
      const sort = sessionStorage.getItem(`${gridId}-sort`) ?? "";
      const context = sessionStorage.getItem(`${gridId}-context`) ?? "";
      const route = `${endpoint}/${page}?focus=${gridId}-${focus}&${sort}&${filter}&${context}`;
      if (!this.inFlight) {
        this.inFlight = true;
        htmx.ajax("GET", route, {
          target: `#${gridId}-data-grid`,
          swap: "outerHTML",
        });
      }
    }
  },
});
